import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

import cache from "memory-cache";

import CommonHeader from "../../../components/Common/Header/";

import Api from "../../../lib/componentApi";
import getComponentData from "../../../lib/getComponentData";

import List from "../../../components/Restaurants/Search/List";
import getRestaurantsLink from "../../../lib/getRestaurantsLink";

class Search extends Component {
  constructor(props, context) {
    super(props, context);
    const staticContext = props.staticContext;
    const { initialData } = getComponentData(staticContext, "searchCategories");

    const popularCategories =
      (props.postLogin && props.popularCategories) ||
      ((initialData &&
        initialData.length &&
        initialData.filter(category => category.isPopular)) ||
        []);
    const notPopularCategories =
      (props.postLogin && props.notPopularCategories) ||
      ((initialData &&
        initialData.length &&
        initialData.filter(category => !category.isPopular)) ||
        []);
    let recents;
    // eslint-disable-next-line
    if (__isBrowser__) {
      recents =
        (localStorage.getItem("recentSearches") &&
          JSON.parse(localStorage.getItem("recentSearches"))) ||
        [];
    }
    this.state = {
      popularCategories,
      notPopularCategories,
      regexCategories: [],
      query: "",
      recentSearches: recents,
      focused: false
    };
  }

  handleKeyUp = event => {
    event.preventDefault();
    const self = this;
    this.interval = setTimeout(self.getData.bind(self), 1000);
  };

  getData() {
    clearTimeout(this.interval);
    const { query } = this.state;
    let deliveryDetails;
    // eslint-disable-next-line
    if (__isBrowser__) {
      deliveryDetails = localStorage.getItem("deliveryDetails");
    } else {
      deliveryDetails = cache.get("deliveryDetails");
    }
    deliveryDetails = (deliveryDetails && JSON.parse(deliveryDetails)) || {};
    let delivery = true;
    let completeData = {
      lat: (deliveryDetails && deliveryDetails.lat) || null,
      lon: (deliveryDetails && deliveryDetails.lon) || null,
      userAddressId: (deliveryDetails && deliveryDetails.userAddressId) || null,
      delivery,
      collectionDistance: (deliveryDetails && deliveryDetails.distance) || 0,
      query
    };
    Api.post("/api/complete", completeData, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code");
      } else {
        this.setState({ regexCategories: response });
      }
    });
  }

  onSelectCategory = (
    categoryName,
    type,
    restaurantPostCode,
    restaurantAdminWard,
    restaurantCity,
    slugName,
    listItem
  ) => {
    if (categoryName === "My Favorites") {
      location.href = "/profile?favorites";
    } else if (type === 1) {
      this.renderRestaurantDetail(
        restaurantPostCode,
        restaurantAdminWard,
        restaurantCity,
        slugName
      );
    } else if (type === 0 || listItem || type === 2) {
      this.redirectRestaurantsList(categoryName);
    } else {
      this.setState({
        focused: false
      });
    }
  };

  componentDidMount() {
    this.interval = null;
  }

  handleChange = event => {
    event.preventDefault();
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  handleFocusQuery = event => {
    event.preventDefault();
    this.setState({ focused: true });
  };
  renderRestaurantDetail = (
    restaurantPostCode,
    restaurantAdminWard,
    restaurantCity,
    slugName
  ) => {
    const deliveryDetails = localStorage.getItem("deliveryDetails");
    const { postalCode, preOrder } = deliveryDetails || "";
    const href = `/restaurant/${restaurantCity}/${restaurantAdminWard}/${slugName}/?postcode=${postalCode ||
      restaurantPostCode}&time=${preOrder || "now"}`;
    if (href) {
      location.href = href;
    }
  };
  redirectRestaurantsList = categoryName => {
    const restaurantLink = getRestaurantsLink();
    let href;
    if (restaurantLink !== "/") {
      href = `${restaurantLink}&query=${categoryName}`;
    } else {
      href = restaurantLink;
    }
    if (href) {
      location.href = href;
    }
  };
  render() {
    const {
      popularCategories,
      notPopularCategories,
      query,
      regexCategories,
      recentSearches,
      focused
    } = this.state;
    const { postLogin } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>Categories</title>
        </Helmet>
        <CommonHeader active="search" />
        <div className="search-page">
          <div className="container">
            <div className="padding">
              {(!postLogin && (
                <div className="form">
                  <input
                    id="query"
                    placeholder="Search (Cuisines or restaurants)"
                    type="text"
                    onKeyUp={this.handleKeyUp}
                    value={query}
                    onFocus={this.handleFocusQuery}
                    onChange={this.handleChange}
                  />
                  <i className="icon icon-search-gray" />
                  {(focused && (
                    <div className="recent-search mt-10px">
                      <div className="title d-flex align-items-center">
                        <icon className="icon icon-clock" />
                        <h5>Recent Searches</h5>
                        <ul>
                          {(recentSearches &&
                            recentSearches.length &&
                            recentSearches.map((search, i) => (
                              <li key={i}>{i}</li>
                            ))) || <noscript />}
                        </ul>
                      </div>
                      {(regexCategories && regexCategories.length && (
                        <ul>
                          {regexCategories.map(category => (
                            <li
                              key={category.id}
                              onClick={() =>
                                this.onSelectCategory(
                                  category.name,
                                  category.resultType,
                                  category.restaurantAddressPostalCode,
                                  category.restaurantAddressSlugAdminWard,
                                  category.restaurantAddressSlugCityName,
                                  category.restaurantSlugName
                                )
                              }
                            >
                              {category.name}
                            </li>
                          ))}
                        </ul>
                      )) || <noscript />}
                    </div>
                  )) || <noscript />}
                </div>
              )) || <noscript />}

              <List
                popularCategories={popularCategories}
                notPopularCategories={notPopularCategories}
                handleSelectCategory={this.onSelectCategory}
              />
            </div>
            {/* .padding */}
          </div>
          {/* .container */}
        </div>
        {/* .search-page */}
      </React.Fragment>
    );
  }
}

export default withRouter(Search);
